module.exports = __webpack_public_path__ + "img/h-docs.38817afa.svg";